import React, { useEffect } from 'react';
import { useRef } from 'react';

const { tableau } = window;

const TableauContainers = (props) => {
    const ref = useRef(null);
    const url = props?.url;
    const options = {
        //device: "desktop",
        width: "100%",
        height: "95vh"
    }

    const initViz = () => {
        new tableau.Viz(ref.current, url, options)
    }

    useEffect(() => {
        initViz();
    }, []);

    return (
        <div>
            <div ref={ref}></div>
        </div>
    )
}

export default TableauContainers;